module.exports = __webpack_public_path__ + "75fe8cf07953a028c45e2b51930653fc.svg";